import React, { useState, useEffect } from 'react';
import { Route, useParams } from 'react-router-dom';
import useCaseFetch from 'api/Case';
import useMedicalRecordFetch from 'api/MedicalRecordsFetch';
import { Box, CircularProgress } from '@material-ui/core';
import MedicalRecord from '../MedicalRecord';
import PatientCase from '../PatientCase';

const PatientCaseContainer = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { caseId, patient } = useParams<{ caseId: string; patient: string }>();

  const { getCase } = useCaseFetch();
  const { getRecords } = useMedicalRecordFetch();

  const loadCase = async () => {
    setLoading(true);
    await getCase(caseId, patient);
    setLoading(false);
  };
  useEffect(() => {
    loadCase();
  }, []);

  return loading ? (
    <Box display="flex" justifyContent="center" alignItems="center" height="500px" width="100%">
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Route exact path="/user/patient_records/:patient/cases/:caseId/medical_records/:recordId" component={MedicalRecord} />
      <Route exact path="/user/patient_records/:patient/cases/:caseId" component={PatientCase} />
    </>
  );
};
export default PatientCaseContainer;
